import { getContentCMS } from 'core/crud/contents.crud';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import TextHtml from 'ui/atoms/TextHtml/TextHtml';

function MaterialPreviewQuiz({ material }) {
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    getQuiz();
  }, []);

  async function getQuiz() {
    const response = await getContentCMS(material.content_guid);
    setQuestions(response?.data?.data?.data?.questions);
  }

  return (
    <div className="material-preview-quiz">
      {questions?.map((question, index) => (
        <div key={question?.content_guid} className="material-preview-quiz__item mb-3">
          <div>
            <span className="material-preview-quiz__box">{index + 1}</span>
          </div>

          <TextHtml isAuthored text={question?.stimulus} />
        </div>
      ))}
    </div>
  );
}

MaterialPreviewQuiz.propTypes = {
  material: PropTypes.shape({
    content_guid: PropTypes.string,
  }),
};

export default MaterialPreviewQuiz;
